import * as React from 'react'
import { Mutation, MutationFunction } from 'react-apollo'
import { Heart } from 'react-feather'

import { LEAD_UNBOOKMARK_MUTATION, LEADS_FOR_PARENT_QUERY } from 'main/gql/lead'
import { LeadUnbookmark, LeadUnbookmarkVariables } from 'main/gql/lead/__generated__/LeadUnbookmark'
import CTAButton from 'main/pages/School/CTA/Content/common/CTAButton'
import { Hidden, palette, Visible } from 'main/ui'
import { useTranslation } from 'react-i18next'
import segment from 'util/analytics/segment'
import { LOCIZE_NAMESPACE } from '../../../../../common'
import { i18nKeyPrefix } from '../../../i18n'
import { AddToFavorites_user } from './gql/__generated__/AddToFavorites'

interface IProps {
  full: boolean
  schoolId: number
  user: AddToFavorites_user | null
  onClick: () => void
}

const PRE = `${i18nKeyPrefix}-CTA-FAVORITES-BOOKMARKED`

export default function Bookmarked(props: IProps) {
  const { full, schoolId, user, onClick } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Mutation<LeadUnbookmark, LeadUnbookmarkVariables>
      mutation={LEAD_UNBOOKMARK_MUTATION}
      refetchQueries={[{ query: LEADS_FOR_PARENT_QUERY }]}
    >
      {mutate => (
        <>
          <Visible lg xl>
            <CTAButton
              full={full}
              icon={<Heart fill={palette.rose2} color={palette.rose2} />}
              kind="outline"
              label={t(`${PRE}-LABEL`)}
              pendo="school-page-bookmark-button"
              onClick={() => handleOnClick(mutate)}
            />
          </Visible>
          <Hidden lg xl>
            <CTAButton
              full={full}
              icon={<Heart fill={palette.rose2} color={palette.rose2} />}
              kind="outline"
              label=""
              pendo="school-page-bookmark-button"
              onClick={() => handleOnClick(mutate)}
            />
          </Hidden>
        </>
      )}
    </Mutation>
  )

  function handleOnClick(mutate: MutationFunction<LeadUnbookmark, LeadUnbookmarkVariables>) {
    if (user) {
      trackUnbookmarkEvent(schoolId)
      mutate({ variables: { schoolId } })
    } else {
      onClick()
    }
  }
}

function trackUnbookmarkEvent(schoolId: number) {
  segment.track('Program Removed From Favorites', { school_id: schoolId })
}
